export const capitalizeString = str => {
  if(typeof str === 'string' && str.length) return `${str.charAt(0).toUpperCase()}${str.substring(1).toLowerCase()}`.trim();
  else return str
}